import Vue from 'vue';
import { Consoler } from './Consoler';

class ConfigDefinition extends Vue 
{
    public readonly GisServicesServicesUrl: string = process.env.VUE_APP_GIS_SERVICES_SERVICES_URL;
    public readonly DefaultMapCoordsLat: number = Number(process.env.VUE_APP_DEFAULT_MAP_COORDS_LAT);
    public readonly DefaultMapCoordsLng: number = Number(process.env.VUE_APP_DEFAULT_MAP_COORDS_LNG);
    public readonly MapProjection: string = process.env.VUE_APP_MAP_PROJECTION;
    public readonly MapZoomNone: number = Number(process.env.VUE_APP_MAP_ZOOM_NONE);
    public readonly MapZoomOk: number = Number(process.env.VUE_APP_MAP_ZOOM_OK);
    public readonly MapZoomGreat: number = Number(process.env.VUE_APP_MAP_ZOOM_GREAT);
    public readonly MapMaxZoom: number = Number(process.env.VUE_APP_MAP_MAX_ZOOM);

    public readonly MapSetReportPointsEvent: string = 'mapSetReportPoints';
    public readonly MapSetPointStyleRulesEvent: string = 'mapSetPointStyleRules';
    public readonly MapClearSelectedPointsEvent: string = 'mapClearSelectedPoints';
    public readonly MapSetFullScreenEvent: string = 'mapSetFullScreen';
    public readonly MapSetShowSidebarRightEvent: string = 'mapSetShowSidebarRight';
    public readonly MapPointSelectedEvent: string = 'mapPointSelected';
    
    public Settings: ConfigSettings = {
        ApiBaseUrl: '',
        UseDataSwitch: false,
        SliderOnTop: false,
        Year: 0,
        SummaryCompareWithLastYear: false,
        ChartsPrimaryColor: '',
        ChartsSecondaryColor: ''
    };

    public SetSettings(settings: ConfigSettings) {
        Consoler.debugLog('Setting settings:', settings);
        this.Settings = settings;
    }
}

export interface ConfigSettings {
    ApiBaseUrl: string;
    UseDataSwitch: boolean;
    SliderOnTop: boolean;
    Year: number;
    SummaryCompareWithLastYear: boolean;
    ChartsPrimaryColor: string;
    ChartsSecondaryColor: string;
}

export const Config = new ConfigDefinition();